import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex flex-center flex-column flex-column-fluid p-10\"><div class=\"text-start d-flex\"><div class=\"mb-6 my-auto mx-5\"><img alt=\"Logo\" src=\"media/logos/logo-1.svg\" class=\"h-50px\"></div><div class=\"mx-5\"><h2 class=\"text-dark mt-3\"> Skills for Employment Investment Program (SEIP) </h2><div><p class=\"mb-0\">Probashi Kalyan Bhaban (Level-16)</p><p>71-72 Old Elephant Road, Eskaton Garden, Dhaka-1000.</p></div></div></div></div>", 1)
const _hoisted_2 = { class: "w-lg-75 bg-white rounded shadow-sm p-5 mx-auto row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-center my-5 row" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-5" }, "Trainee Registration")
], -1)
const _hoisted_4 = { class: "card mb-5 mb-xl-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Trainee Registration")
  ])
], -1)
const _hoisted_6 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_7 = { class: "collapse show" }
const _hoisted_8 = { class: "card-body border-top p-6" }
const _hoisted_9 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Sector Name", -1)
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course Name", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "col-md-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Location")
], -1)
const _hoisted_18 = { class: "row mt-4" }
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee_email",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Email Verification")
  ])
], -1)
const _hoisted_27 = {
  id: "register_trainee_email",
  class: "collapse show"
}
const _hoisted_28 = { class: "collapse show" }
const _hoisted_29 = { class: "card-body border-top p-6" }
const _hoisted_30 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Name", -1)
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Mobile", -1)
const _hoisted_36 = { class: "col-md-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Email")
], -1)
const _hoisted_38 = { class: "col-md-2 mt-2" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee_email_otp",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "OTP Verification")
  ])
], -1)
const _hoisted_42 = {
  id: "register_trainee_email_otp",
  class: "collapse show"
}
const _hoisted_43 = { class: "collapse show" }
const _hoisted_44 = { class: "card-body border-top p-6" }
const _hoisted_45 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-md-3" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "OTP", -1)
const _hoisted_49 = { class: "col-md-2 mt-2" }
const _hoisted_50 = {
  key: 2,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee_nid",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "NID Verification")
  ])
], -1)
const _hoisted_52 = {
  id: "register_trainee_nid",
  class: "collapse show"
}
const _hoisted_53 = { class: "collapse show" }
const _hoisted_54 = { class: "card-body border-top p-6" }
const _hoisted_55 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-md-3" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Date of Birth", -1)
const _hoisted_59 = { class: "d-flex mb-0" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-angle-double-right",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_61 = [
  _hoisted_60
]
const _hoisted_62 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "NID", -1)
const _hoisted_64 = { class: "d-flex mb-0" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-search",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = {
  key: 1,
  class: "col-md-1 my-auto text-center"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "form-label mt-7" }, "OR", -1)
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = {
  key: 2,
  class: "col-md-4"
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "BCN", -1)
const _hoisted_72 = { class: "d-flex mb-0" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-search",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = {
  key: 3,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#employee_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Application Information")
  ])
], -1)
const _hoisted_77 = {
  id: "employee_information",
  class: "collapse show"
}
const _hoisted_78 = { class: "collapse show" }
const _hoisted_79 = { class: "card-body border-top p-9" }
const _hoisted_80 = { class: "row d-flex" }
const _hoisted_81 = { class: "col-md-3" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Upload Employee Image", -1)
const _hoisted_83 = { id: "preview" }
const _hoisted_84 = ["src"]
const _hoisted_85 = { class: "col-md-9" }
const _hoisted_86 = { class: "row mt-3 d-flex" }
const _hoisted_87 = { class: "col-md-4" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Name", -1)
const _hoisted_89 = { class: "col-md-4" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Father Name", -1)
const _hoisted_91 = { class: "col-md-4" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, " Mother Name ", -1)
const _hoisted_93 = { class: "row mt-3 d-flex" }
const _hoisted_94 = { class: "col-md-8" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present Address")
], -1)
const _hoisted_96 = { class: "col-md-4" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present District")
], -1)
const _hoisted_98 = { class: "row mt-3 d-flex" }
const _hoisted_99 = { class: "col-md-6" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present Upazilla")
], -1)
const _hoisted_101 = { class: "col-md-6" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present Post Code")
], -1)
const _hoisted_103 = { class: "row mt-3" }
const _hoisted_104 = { class: "col-md-4" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent Address")
], -1)
const _hoisted_106 = { class: "col-md-3" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent District")
], -1)
const _hoisted_108 = { class: "col-md-3" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent Upazilla")
], -1)
const _hoisted_110 = { class: "col-md-2" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Post Code")
], -1)
const _hoisted_112 = {
  key: 4,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#personal_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Personal Information")
  ])
], -1)
const _hoisted_114 = {
  id: "personal_information",
  class: "collapse show"
}
const _hoisted_115 = { class: "collapse show" }
const _hoisted_116 = { class: "card-body border-top p-9" }
const _hoisted_117 = { class: "row mt-3" }
const _hoisted_118 = { class: "col-md-3" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Ethnic Group")
], -1)
const _hoisted_120 = { class: "col-md-3" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Highest Class Completed")
], -1)
const _hoisted_122 = { class: "col-md-3" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Passing Year")
], -1)
const _hoisted_124 = { class: "col-md-3" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Is Employed?")
], -1)
const _hoisted_126 = { class: "row mt-3" }
const _hoisted_127 = { class: "col-md-3" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Years of Experience")
], -1)
const _hoisted_129 = { class: "col-md-3" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Personal Monthly Income")
], -1)
const _hoisted_131 = { class: "col-md-3" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Home District")
], -1)
const _hoisted_133 = { class: "col-md-3" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Home Upazilla")
], -1)
const _hoisted_135 = { class: "row mt-3" }
const _hoisted_136 = { class: "col-md-3" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Is Physically Challenged?")
], -1)
const _hoisted_138 = { class: "col-md-3" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Remarks")
], -1)
const _hoisted_140 = { class: "col-md-3" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Religion", -1)
const _hoisted_142 = { class: "col-md-3" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Gender", -1)
const _hoisted_144 = {
  key: 5,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_145 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#family_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Family Information")
  ])
], -1)
const _hoisted_146 = {
  id: "family_information",
  class: "collapse show"
}
const _hoisted_147 = { class: "collapse show" }
const _hoisted_148 = { class: "card-body border-top p-9" }
const _hoisted_149 = { class: "row" }
const _hoisted_150 = { class: "col-md-3" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Mother's Education Level", -1)
const _hoisted_152 = { class: "col-md-3" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Mother's Occupation", -1)
const _hoisted_154 = { class: "col-md-3" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Father's Education Level")
], -1)
const _hoisted_156 = { class: "col-md-3" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Father's Occupation")
], -1)
const _hoisted_158 = { class: "row mt-3" }
const _hoisted_159 = { class: "col-md-3" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Family Annual Income")
], -1)
const _hoisted_161 = { class: "col-md-3" }
const _hoisted_162 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Number of Siblings?")
], -1)
const _hoisted_163 = { class: "col-md-3" }
const _hoisted_164 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Have family owned home?", -1)
const _hoisted_165 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_166 = { class: "col-md-3" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Have family owned land?", -1)
const _hoisted_168 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_169 = { key: 6 }
const _hoisted_170 = { class: "d-flex" }
const _hoisted_171 = ["data-kt-indicator"]
const _hoisted_172 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_173 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_174 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_175 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_176 = /*#__PURE__*/_createStaticVNode("<div class=\"row d-flex m-5\"><div class=\"col-md-6 text-start\"><div class=\"mt-5\"><img src=\"media/logos/bangladesh-govt.png\" class=\"mr-2 h-65px\"><img src=\"media/logos/Adb-logo-block.jpg\" class=\"mr-2 h-65px\"><img src=\"media/logos/sdc.png\" class=\"h-65px\"></div></div><div class=\"col-md-6 text-end my-auto\"></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Form, {
        class: "form",
        onSubmit: _cache[58] || (_cache[58] = ($event: any) => (_ctx.formSubmit())),
        "validation-schema": _ctx.TrainerSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createVNode(_component_el_select, {
                          class: "form-select-solid",
                          placeholder: "Select Sector Name",
                          modelValue: _ctx.trainee.course_sector,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainee.course_sector) = $event)),
                          filterable: "",
                          style: {"width":"100%"},
                          name: "course_sector",
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getCourseList()))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseSectors, (data) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: data.id,
                                label: data.sector_name,
                                value: data.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(data.sector_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "course_sector",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _hoisted_15,
                        _createVNode(_component_el_select, {
                          class: "form-select-solid",
                          "collapse-tags": "",
                          placeholder: "Select Course",
                          modelValue: _ctx.trainee.course_info_id,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.trainee.course_info_id) = $event)),
                          filterable: "",
                          style: {"width":"100%"},
                          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getLocation()))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: course.id,
                                label: course.course_name,
                                value: course.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(course.course_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "course",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _createVNode(_component_el_select, {
                          class: "form-select-solid",
                          placeholder: "Select District",
                          modelValue: _ctx.trainee.location,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.trainee.location) = $event)),
                          filterable: "",
                          style: {"width":"100%"},
                          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.associationList()))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (district) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: district.id,
                                label: district.district_name_eng,
                                value: district.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "present_districts",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _hoisted_21,
                        _createVNode(_component_el_select, {
                          class: "form-select-solid",
                          placeholder: "Select Partner",
                          modelValue: _ctx.trainee.entity_id,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.trainee.entity_id) = $event)),
                          filterable: "",
                          onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.trainingInstitute())),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associations, (assoc) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: assoc.id,
                                label: assoc.entity_short_name,
                                value: assoc.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(assoc.entity_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "training_partner",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _hoisted_24,
                        _createVNode(_component_el_select, {
                          class: "form-select-solid",
                          placeholder: "Select Institute",
                          modelValue: _ctx.trainee.training_institute_id,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.trainee.training_institute_id) = $event)),
                          filterable: "",
                          style: {"width":"100%"},
                          onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showEmailVerify(_ctx.trainee.batch_info_id)))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutes, (inst) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: inst.id,
                                label: inst.institute_name,
                                value: inst.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(inst.institute_name), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "training_institute",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.showEmailVerifyForm == true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            _createVNode(_component_Field, {
                              modelValue: _ctx.trainee.trainee_name,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.trainee.trainee_name) = $event)),
                              type: "text",
                              name: "name",
                              class: "form-control form-control-sm",
                              style: {"height":"40px","width":"100%"}
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "name",
                              class: "fv-plugins-message-container invalid-feedback"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _hoisted_35,
                            _createVNode(_component_Field, {
                              modelValue: _ctx.trainee.mobile,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.trainee.mobile) = $event)),
                              name: "mobile",
                              class: "form-control form-control-sm",
                              style: {"height":"40px","width":"100%"}
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "mobile",
                              class: "fv-plugins-message-container invalid-feedback"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _hoisted_37,
                            _createVNode(_component_Field, {
                              modelValue: _ctx.trainee.email,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.trainee.email) = $event)),
                              name: "email",
                              class: "form-control form-control-sm",
                              style: {"height":"40px","width":"100%"}
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "email",
                              class: "fv-plugins-message-container invalid-feedback"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("button", {
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.emailVerify())),
                              disabled: _ctx.emailbtnIsDisabled,
                              class: "btn btn-success mt-6 p-3",
                              style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                            }, " Verify ", 8, _hoisted_39)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showOtpVerifyForm == true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                _hoisted_41,
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _createVNode(_component_Field, {
                              modelValue: _ctx.trainee_otp,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.trainee_otp) = $event)),
                              type: "text",
                              name: "trainee_otp",
                              class: "form-control form-control-sm",
                              style: {"height":"40px","width":"100%"}
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "trainee_otp",
                              class: "fv-plugins-message-container invalid-feedback"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("button", {
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.otpVerify())),
                              type: "button",
                              class: "btn btn-success mt-6 p-3",
                              style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                            }, " Verify ")
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showNidVerifyForm == true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _createElementVNode("div", _hoisted_57, [
                            _hoisted_58,
                            _createElementVNode("div", _hoisted_59, [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.trainee.date_of_birth,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.trainee.date_of_birth) = $event)),
                                "value-format": "YYYY-MM-DD",
                                format: "DD-MM-YYYY",
                                type: "date",
                                name: "dob",
                                style: {"width":"100%","border-top-right-radius":"0","border-bottom-right-radius":"0"}
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("button", {
                                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.checkDob())),
                                type: "button",
                                class: "btn btn-success p-3",
                                title: "Next",
                                style: {"padding-top":"8px !important","padding-bottom":"8px !important","border-top-left-radius":"0","margin-left":"-1px","border-bottom-left-radius":"0"}
                              }, _hoisted_61)
                            ]),
                            _createVNode(_component_ErrorMessage, {
                              name: "date_of_birth",
                              class: "fv-plugins-message-container invalid-feedback"
                            })
                          ]),
                          (_ctx.showNidField == true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                _hoisted_63,
                                _createElementVNode("div", _hoisted_64, [
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.trainee.nid,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.trainee.nid) = $event)),
                                    name: "nid",
                                    class: "form-control form-control-sm",
                                    type: "number"
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("button", {
                                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.verifyNid())),
                                    type: "button",
                                    class: "btn btn-success p-3",
                                    title: "Search",
                                    style: {"padding-top":"8px !important","padding-bottom":"8px !important","border-top-left-radius":"0","margin-left":"-5px","border-bottom-left-radius":"0"}
                                  }, _hoisted_66)
                                ]),
                                _createVNode(_component_ErrorMessage, {
                                  name: "nid",
                                  class: "fv-plugins-message-container invalid-feedback"
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.showBCNField == true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_67, _hoisted_69))
                            : _createCommentVNode("", true),
                          (_ctx.showBCNField == true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                _hoisted_71,
                                _createElementVNode("div", _hoisted_72, [
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.trainee.bcn,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.trainee.bcn) = $event)),
                                    name: "bcn",
                                    class: "form-control form-control-sm",
                                    type: "number"
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("button", {
                                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.verifyBCN())),
                                    type: "button",
                                    class: "btn btn-success p-3",
                                    title: "Next",
                                    style: {"padding-top":"8px !important","padding-bottom":"8px !important","border-top-left-radius":"0","margin-left":"-5px","border-bottom-left-radius":"0"}
                                  }, _hoisted_74)
                                ]),
                                _createVNode(_component_ErrorMessage, {
                                  name: "bcn",
                                  class: "fv-plugins-message-container invalid-feedback"
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showTraineeForm == true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                _hoisted_76,
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("div", _hoisted_81, [
                          _hoisted_82,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.trainee.photo,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.trainee.photo) = $event)),
                            name: "photo",
                            ref: "traineeFileInput",
                            onChange: _ctx.traineePhoto,
                            type: "file",
                            class: "form-control"
                          }, null, 8, ["modelValue", "onChange"]),
                          _createElementVNode("div", _hoisted_83, [
                            (_ctx.url)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: _ctx.url
                                }, null, 8, _hoisted_84))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(_component_ErrorMessage, {
                            name: "trainee_image",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_85, [
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("div", _hoisted_87, [
                              _hoisted_88,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.trainee.trainee_name,
                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.trainee.trainee_name) = $event)),
                                type: "text",
                                name: "name",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "name",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_89, [
                              _hoisted_90,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.trainee.father_name,
                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.trainee.father_name) = $event)),
                                name: "father_name",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "father_name",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_91, [
                              _hoisted_92,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.trainee.mother_name,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.trainee.mother_name) = $event)),
                                name: "mother_name",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "mother_name",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_93, [
                            _createElementVNode("div", _hoisted_94, [
                              _hoisted_95,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.trainee.present_address,
                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.trainee.present_address) = $event)),
                                name: "present_address",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_96, [
                              _hoisted_97,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select District",
                                modelValue: _ctx.trainee.present_district,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.trainee.present_district) = $event)),
                                filterable: "",
                                style: {"width":"100%"},
                                onChange: _cache[28] || (_cache[28] = ($event: any) => (_ctx.getSubDistrict()))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: district.id,
                                      label: district.district_name_eng,
                                      value: district.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "present_districts",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_98, [
                            _createElementVNode("div", _hoisted_99, [
                              _hoisted_100,
                              _createVNode(_component_el_select, {
                                class: "form-select-solid",
                                placeholder: "Select Upazilla",
                                modelValue: _ctx.trainee.present_upazilla,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.trainee.present_upazilla) = $event)),
                                filterable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subDistricts, (sub_district) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: sub_district.id,
                                      label: sub_district.upazila_name_eng,
                                      value: sub_district.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(sub_district.upazila_name_eng), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "present_upazilla",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_101, [
                              _hoisted_102,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.trainee.present_post_code,
                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.trainee.present_post_code) = $event)),
                                name: "present_post_code",
                                class: "form-control form-control-sm",
                                style: {"height":"40px","width":"100%"}
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, {
                                name: "present_post_code",
                                class: "fv-plugins-message-container invalid-feedback"
                              })
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_103, [
                        _createElementVNode("div", _hoisted_104, [
                          _hoisted_105,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.trainee.per_address,
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.trainee.per_address) = $event)),
                            name: "permanent_address",
                            class: "form-control form-control-sm",
                            style: {"height":"40px","width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_106, [
                          _hoisted_107,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select District",
                            modelValue: _ctx.trainee.per_district,
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.trainee.per_district) = $event)),
                            filterable: "",
                            style: {"width":"100%"},
                            onChange: _cache[33] || (_cache[33] = ($event: any) => (_ctx.getPermanentSubDistrict()))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: district.id,
                                  label: district.district_name_eng,
                                  value: district.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "permanent_districts",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_108, [
                          _hoisted_109,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Upazilla",
                            modelValue: _ctx.trainee.per_upazilla,
                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.trainee.per_upazilla) = $event)),
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subPermanentDistrict, (subpermanent_district) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: subpermanent_district.id,
                                  label: subpermanent_district.upazila_name_eng,
                                  value: subpermanent_district.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(subpermanent_district.upazila_name_eng), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "permanent_upazilla",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_110, [
                          _hoisted_111,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.trainee.per_post_code,
                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.trainee.per_post_code) = $event)),
                            name: "post_code_address",
                            class: "form-control form-control-sm",
                            style: {"height":"40px","width":"100%"}
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "per_post_code",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showTraineeForm == true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                _hoisted_113,
                _createElementVNode("div", _hoisted_114, [
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("div", _hoisted_116, [
                      _createElementVNode("div", _hoisted_117, [
                        _createElementVNode("div", _hoisted_118, [
                          _hoisted_119,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Class",
                            modelValue: _ctx.trainee.ethnic_group,
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.trainee.ethnic_group) = $event)),
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ethnicGroups, (group) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: group.id,
                                  label: group.group_name,
                                  value: group.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(group.group_name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_120, [
                          _hoisted_121,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Class",
                            modelValue: _ctx.trainee.highest_class_completed,
                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.trainee.highest_class_completed) = $event)),
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, { value: "Masters" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Masters")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Bachelor" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Bachelor")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "HSC" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("HSC")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "SSC" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("SSC")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "JSC" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("JSC")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "PSC" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("PSC")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_122, [
                          _hoisted_123,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Class",
                            modelValue: _ctx.trainee.highest_class_completed_year,
                            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.trainee.highest_class_completed_year) = $event)),
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(30, (index) => {
                                return _createVNode(_component_el_option, {
                                  key: index,
                                  value: _ctx.currentYear + 1 - index
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.currentYear + 1 - index), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"])
                              }), 64))
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "passing_year",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_124, [
                          _hoisted_125,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Status",
                            modelValue: _ctx.trainee.is_employed,
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.trainee.is_employed) = $event)),
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, { value: "Yes" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Yes")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "No" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("No")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "is_employee",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_126, [
                        _createElementVNode("div", _hoisted_127, [
                          _hoisted_128,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.trainee.year_of_experience,
                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.trainee.year_of_experience) = $event)),
                            name: "experience_year",
                            class: "form-control form-control-sm",
                            style: {"height":"40px","width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_129, [
                          _hoisted_130,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.trainee.family_monthly_income,
                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.trainee.family_monthly_income) = $event)),
                            name: "monthly_income",
                            class: "form-control form-control-sm",
                            style: {"height":"40px","width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_131, [
                          _hoisted_132,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select District",
                            modelValue: _ctx.trainee.home_district,
                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.trainee.home_district) = $event)),
                            filterable: "",
                            style: {"width":"100%"},
                            onChange: _cache[43] || (_cache[43] = ($event: any) => (_ctx.getHomeSubDistrict()))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: district.id,
                                  label: district.district_name_eng,
                                  value: district.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(district.district_name_eng), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_133, [
                          _hoisted_134,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Upazilla",
                            modelValue: _ctx.trainee.home_upazilla,
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.trainee.home_upazilla) = $event)),
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subHomeSubDistrict, (subpermanent_district) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: subpermanent_district.id,
                                  label: subpermanent_district.upazila_name_eng,
                                  value: subpermanent_district.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(subpermanent_district.upazila_name_eng), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_135, [
                        _createElementVNode("div", _hoisted_136, [
                          _hoisted_137,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Status",
                            modelValue: _ctx.trainee.is_physically_challenged,
                            "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.trainee.is_physically_challenged) = $event)),
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, { value: "Yes" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Yes")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "No" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("No")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "is_physically",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_138, [
                          _hoisted_139,
                          _createVNode(_component_Field, {
                            name: "remarks",
                            modelValue: _ctx.trainee.challenge_remarks,
                            "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.trainee.challenge_remarks) = $event)),
                            class: "form-control form-control-sm",
                            style: {"height":"40px","width":"100%"}
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "remarks",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_140, [
                          _hoisted_141,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Status",
                            modelValue: _ctx.trainee.religion,
                            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.trainee.religion) = $event)),
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, { value: "Islam" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Islam")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Hindu" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Hindu")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Christian" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Christian")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Buddhist" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Buddhist")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "religion",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_142, [
                          _hoisted_143,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Status",
                            modelValue: _ctx.trainee.gender,
                            "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.trainee.gender) = $event)),
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, { value: "Male" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Male")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Female" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Female")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Other" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Other")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "gender",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showTraineeForm == true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                _hoisted_145,
                _createElementVNode("div", _hoisted_146, [
                  _createElementVNode("div", _hoisted_147, [
                    _createElementVNode("div", _hoisted_148, [
                      _createElementVNode("div", _hoisted_149, [
                        _createElementVNode("div", _hoisted_150, [
                          _hoisted_151,
                          _createVNode(_component_Field, {
                            type: "text",
                            name: "mother_education_level",
                            modelValue: _ctx.trainee.mother_education_level,
                            "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.trainee.mother_education_level) = $event)),
                            class: "form-control form-control-sm",
                            style: {"height":"40px","width":"100%"}
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "mother_edu",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_152, [
                          _hoisted_153,
                          _createVNode(_component_Field, {
                            name: "mother_occ",
                            modelValue: _ctx.trainee.mother_occupation,
                            "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.trainee.mother_occupation) = $event)),
                            class: "form-control form-control-sm",
                            style: {"height":"40px","width":"100%"}
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "mother_occ",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_154, [
                          _hoisted_155,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.trainee.father_education_level,
                            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.trainee.father_education_level) = $event)),
                            name: "father_edu",
                            class: "form-control form-control-sm",
                            style: {"height":"40px","width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_156, [
                          _hoisted_157,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.trainee.father_occupation,
                            "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.trainee.father_occupation) = $event)),
                            name: "father_occ",
                            class: "form-control form-control-sm",
                            style: {"height":"40px","width":"100%"}
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_158, [
                        _createElementVNode("div", _hoisted_159, [
                          _hoisted_160,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.trainee.father_annual_income,
                            "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.trainee.father_annual_income) = $event)),
                            name: "family_income",
                            class: "form-control form-control-sm",
                            style: {"height":"40px","width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_161, [
                          _hoisted_162,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.trainee.number_of_siblings,
                            "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.trainee.number_of_siblings) = $event)),
                            name: "sibling_no",
                            type: "number",
                            min: "0",
                            class: "form-control form-control-sm",
                            style: {"height":"40px","width":"100%"}
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_163, [
                          _hoisted_164,
                          _hoisted_165,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Status",
                            modelValue: _ctx.trainee.have_family_owned_home,
                            "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.trainee.have_family_owned_home) = $event)),
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, { value: "Yes" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Yes")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "No" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("No")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "family_own_home",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ]),
                        _createElementVNode("div", _hoisted_166, [
                          _hoisted_167,
                          _hoisted_168,
                          _createVNode(_component_el_select, {
                            class: "form-select-solid",
                            placeholder: "Select Status",
                            modelValue: _ctx.trainee.have_family_owned_land,
                            "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.trainee.have_family_owned_land) = $event)),
                            filterable: "",
                            style: {"width":"100%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, { value: "Yes" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Yes")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "No" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("No")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "family_own_land",
                            class: "fv-plugins-message-container invalid-feedback"
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showTraineeForm == true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
                _createElementVNode("div", _hoisted_170, [
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      "data-kt-indicator": _ctx.loading ? 'on' : null,
                      class: "btn btn-lg btn-success",
                      type: "submit",
                      onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.formSubmit()))
                    }, [
                      (!_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_172, [
                            _createTextVNode(" Submit "),
                            _createElementVNode("span", _hoisted_173, [
                              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_174, [
                            _createTextVNode(" Please wait... "),
                            _hoisted_175
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_171)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ]),
    _hoisted_176
  ], 64))
}